module.exports = __webpack_public_path__ + "static/media/chiro.94ab186b.jpg";